import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
  SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
  REQUESTED,
  SUCCESSFUL,
  FAILED,
  ADD_VIDEO_REQUESTED,
  ADD_VIDEO_SUCCESSFUL,
  ADD_VIDEO_FAILED,
  SAVE_VIDEO_DETAILS,
  SAVE_USER_IMAGE,
  SET_CURRENT_VIDEO,
  GET_TOTAL_COUNTS_REQUESTED_PROFILE,
  GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE,
  GET_TOTAL_COUNTS_FAILED_PROFILE,
  REMOVE_VIDEO_REQUESTED,
  REMOVE_VIDEO_FAILED,
  REMOVE_VIDEO_SUCCESSFUL,
  INCREASE_CONTACT_COUNT,
} from './actionTypes';

import * as helpers from './functions';

export const initialState = Map({
  profile: Map(),
  error: Map(),
  requested: false,
  videos: [],
  isLoading: false,
  currentVideoUrl: '',
  totalCounts: {},
  totalCountsLoading: false,
  payload: Map(),
  subscribed: false,
});

const handlers = {
  [REQUESTED](state) {
    return state.merge({
      requested: true,
      error: Map(),
      isLoading: true,
    });
  },
  [FAILED](state, action) {
    return state.merge({
      requested: false,
      error: action.error,
    });
  },
  [SUCCESSFUL](state, action) {
    return state.merge({
      requested: false,
      profile: action.profile,
      payload: helpers.generatePayload(action.profile),
      subscribed: helpers.getSubscription(action.profile),
      error: Map(),
      isLoading: false,
    });
  },
  [ADD_VIDEO_REQUESTED](state) {
    return state.merge({
      isLoading: false,
    });
  },
  [ADD_VIDEO_SUCCESSFUL](state, action) {
    return state.merge({
      isLoading: false,
      profile: action.profile,
    });
  },
  [ADD_VIDEO_FAILED](state) {
    return state.merge({
      isLoading: false,
    });
  },
  [SAVE_VIDEO_DETAILS](state, action) {
    return state.merge({
      videos: action.video,
    });
  },
  [SAVE_USER_IMAGE](state, action) {
    return state.merge({
      videos: action.video,
    });
  },
  [SET_CURRENT_VIDEO](state, action) {
    return state.merge({
      currentVideoUrl: action.url,
    });
  },
  [GET_TOTAL_COUNTS_REQUESTED_PROFILE](state) {
    return state.merge({
      totalCountsLoading: true,
    });
  },
  [GET_TOTAL_COUNTS_FAILED_PROFILE](state) {
    return state.merge({
      totalCountsLoading: false,
    });
  },
  [GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE](state, action) {
    return state.merge({
      totalCounts: action.data,
      totalCountsLoading: false,
    });
  },
  [REMOVE_VIDEO_REQUESTED](state) {
    return state.merge({
      isLoading: true,
    });
  },
  [REMOVE_VIDEO_FAILED](state) {
    return state.merge({
      isLoading: false,
    });
  },
  [REMOVE_VIDEO_SUCCESSFUL](state, action) {
    return state.merge({
      profile: action.profile,
      isLoading: false,
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      profile: Map(),
      error: Map(),
      requested: false,
      videos: [],
      isLoading: false,
      currentVideoUrl: '',
    });
  },
  [INCREASE_CONTACT_COUNT](state, action) {
    return state.merge({
      profile: action.profile,
    });
  },
};

export const SAProfilePage = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getError = state => state.SAProfilePage.get('error');
const getProfile = state => state.SAProfilePage.get('profile');
const IsRequested = state => state.SAProfilePage.get('requested');
const getVideo = state => state.SAProfilePage.get('videos');
const getisLoading = state => state.SAProfilePage.get('isLoading');
const getCurrentVideoUrl = state => state.SAProfilePage.get('currentVideoUrl');
const gettotalCountsLoading = state => state.SAProfilePage.get('totalCountsLoading');
const getTotalCounts = state => state.SAProfilePage.get('totalCounts');
const getPayload = state => state.SAProfilePage.get('payload');
const getSubscribed = state => state.SAProfilePage.get('subscribed');


export const selector = createStructuredSelector({
  error: getError,
  profile: getProfile,
  requested: IsRequested,
  videos: getVideo,
  isLoading: getisLoading,
  currentVideoUrl: getCurrentVideoUrl,
  totalCounts: getTotalCounts,
  totalCountsLoading: gettotalCountsLoading,
  payload: getPayload,
  subscribed: getSubscribed,
});



// WEBPACK FOOTER //
// ./src/containers/Profile-view/redux.js